export default {
    default: {
        breakpoints: undefined
    },
    product: {
        breakpoints: {
            320: {
                slidesPerGroup: 2
            },
            768: {
                slidesPerGroup: 4
            },
            1536: {
                slidesPerGroup: 5
            },
            1700: {
                slidesPerGroup: 6
            }
        }
    }
}
